import {
  GENERATE_INSPECTION_PDF_SUCCESS,
  GENERATE_INSPECTION_PDF_FAILED,
  CLEAR_INSPECTION_REPORT,
} from "./types";

const initialState = {
  current: {
    inspectionReport: null
  }
};

export default function inspectionsReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GENERATE_INSPECTION_PDF_SUCCESS:
      return {
        ...state,
        current: {
          inspectionReport: action.payload
        },
      };
    case GENERATE_INSPECTION_PDF_FAILED:
      return {
        ...state,
        current: {
          error: action.payload
        }
      };
    case CLEAR_INSPECTION_REPORT:
      return {
        ...state,
        current: {
          inspectionReport: null
        },
      };
    default:
      break;
  }
  return state;
};